import { DateTime } from 'luxon'
/**
* Formata a data no padrão brasileiro.
*
* @param {datetime} dataTime seguindo o formato yyyy-dd-MM HH:mm:ss
* @returns Data formatada no padrão dd/MM/yyyy
*/
export function dateTimeFormat (dataTime) {
    const dt = DateTime.fromSQL(dataTime, { zone: 'America/Sao_Paulo' })
        .setLocale('pt')
        .toFormat('dd/MM/yyyy HH:mm:ss')
    return dt
}

/**
* Formata a hora no padrão brasileiro.
*
* @param {datetime} dataTime seguindo o formato yyyy-dd-MM
* @returns Hora formatada no padrão dd/MM/yyyy
*/
export function timeFormat (dataTime) {
    const dt = DateTime.fromSQL(dataTime, { zone: 'America/Sao_Paulo' })
        .setLocale('pt')
        .toFormat('HH:mm:ss')
    return dt
}

export function telephoneMask (tel) {
    if (!tel) { return }
    tel = tel.toString()
    if (tel.length < 10) { return '' }
    return tel.length < 10 ? '-' : tel.length == 10 ? `(${tel[0]}${tel[1]}) ${tel[2]}${tel[3]}${tel[4]}${tel[5]}-${tel[6]}${tel[7]}${tel[8]}${tel[9]}`
        : `(${tel[0]}${tel[1]}) ${tel[2]} ${tel[3]}${tel[4]}${tel[5]}${tel[6]}-${tel[7]}${tel[8]}${tel[9]}${tel[10]}`
}

export function cnpjMask (cnpj) {
    if (!cnpj) { return }
    return cnpj.slice(0, 2) + '.' + cnpj.slice(2, 5) + '.' + cnpj.slice(5, 8) + '/' + cnpj.slice(8, 12) + '-' + cnpj.slice(12, 14)
}

export function dateMask (data) {
    const dataOnly = data.split(' ')[0]
    const split = dataOnly.split('-')
    return split[2] + '/' + split[1] + '/' + split[0]
}
export function hourMask (hora) {
    return hora.split(' ')[1]
}
// "100000000".replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")
